import { css } from "@linaria/core";
import React, { memo } from "react";
import cx from "classnames";
import t from "../../../../../../../../i18n";
import { colors, shadows, spacings } from "@ui/Theme";
import { Text } from "@ui/Text";
import AddFill from "@ui/IconV2/react/AddFill";

export const AddBlockButton = memo(
  ({
    onClick,
    className,
  }: {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
  }) => (
    <button
      className={cx(addBlockButton, className)}
      type="button"
      onClick={e => {
        onClick(e);
        // @note Remove focus from the button as it trigger
        // some synthetic events event if we already focused on another element
        (e.target as HTMLButtonElement).blur();
      }}
    >
      <AddFill size="m" />
      <Text type="body1" as="span">
        {t("project.dashboard.actions.block.add")}
      </Text>
    </button>
  ),
);

const addBlockButton = css`
  align-items: center;
  justify-content: center;
  background-color: ${colors.hydrogen};
  border-radius: 4px;
  border: solid 1px ${colors.titanium200};
  color: ${colors.carbon700};
  cursor: pointer;
  display: flex;
  height: 100%;
  min-height: 32px;
  gap: ${spacings.xxs};
  padding: 0 24px;
  text-align: left;
  transition:
    border-style 100ms ease-in-out,
    box-shadow 100ms ease-in-out,
    opacity 100ms ease-in-out 100ms;
  width: 100%;

  &:hover {
    opacity: 1;
    border-style: solid;
    box-shadow: ${shadows.shadow200};
  }
`;
